<!-- Global toast for all notifications -->
<p-toast position="top-right" styleClass="global-toast"></p-toast>

<router-outlet></router-outlet>